
import VButton from '@/components/ui/VButton';

export default {
    name: 'LayoutError',
    components: {
        VButton
    }
}
